module.exports = __webpack_public_path__ + "media/Icons/StartedIconInverted-6dcad4ca.png";